import { is, complement, isEmpty } from 'ramda';

export const isString = (value: any): value is string => is(String)(value);
export const isNumber = is(Number);
export const isObject = (value: any): value is object => is(Object)(value);

export const isNotNumber = complement(isNumber);

export const isEmptyObject = (value: any): boolean => isObject(value) && isEmpty(value);
